import moment from 'moment'
import { useState } from 'react'

import ConfirmationDialog from '../../../../components/ReusableComponents/ConfirmationDialog/index'
import { resentReasons } from '../../../../main/blacklistHelpers'
import styles from '../Generic/GenericWarning.module.scss'

const SendWarningDialog = ({
  sentDate,
  sendBy,
  handleConfirm,
  handleHideDialog,
  ...props
}) => {
  const [reason, setReason] = useState('select')

  return (
    <ConfirmationDialog
      {...props}
      positiveMessage="Resend"
      negativeMessage="Back"
      isButtonDisabled={reason === 'select'}
      onConfirm={() => handleConfirm(reason)}
      onClose={handleHideDialog}
      title={`Are you sure you want to resend?`}
    >
      <div className={styles.container}>
        <p className={styles.p}>
          This invoice is already sent on{' '}
          <strong>{moment(sentDate).format('MMM D')}</strong> by <strong>{sendBy}</strong>
          . Resend only if hotel requested a reconciliation.
        </p>
        <select onChange={e => setReason(e.target.value)} value={reason}>
          <option value="select">Select a reason to resend</option>
          {Object.keys(resentReasons).map(k => (
            <option value={k}>{resentReasons[k]}</option>
          ))}
        </select>
      </div>
    </ConfirmationDialog>
  )
}

export default SendWarningDialog
